'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Frame = Frame;
exports.Drag = Drag;
exports.Animated = Animated;
exports.timed = timed;
exports.spring = spring;
function Frame(x, y, width, height) {
  return { x: x, y: y, width: width, height: height };
}

function Drag(value, config) {
  return {
    type: 'drag',
    value: value,
    config: config
  };
}

function Animated(value, config, onEnd) {
  return {
    type: 'animated',
    value: value,
    config: config,
    onEnd: onEnd
  };
}

function timed() {
  var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;

  return {
    type: 'timed',
    duration: duration
  };
}

function spring() {
  var spring = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 180;
  var friction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 12;

  return {
    type: 'spring',
    spring: spring,
    friction: friction
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/Markers.js
// module id = 170
// module chunks = 0